<template>
  <div class="page theme-transition">
    <div class="header-section">
      <div class="header-content">
        <h1 class="greeting">{{ greeting() }}</h1>
        <p v-if="curUser" class="username">{{ curUser }}</p>
      </div>
    </div>
    <div class="form-section">
      <div class="form-container">
        <FloatAssignForm/>
      </div>
    </div>
  </div>
</template>

<script>
import FloatAssignForm from "@/components/point-of-sale/float/FloatAssignForm";
import {Storage} from "@/services/Storage";

export default {
  name: "FloatView",
  beforeMount() {
    auth.isCashierLoggedIn().then((res)=>{
      if (!res){
        return this.$router.push({ name : 'setup' })
      }else{
        auth.isFloatSet(this.curUser).then(async (res)=>{
          if(res){
            let settings = await Storage.getDeviceSettings();
            if (settings.PosType === `Retail`|| settings.PosType === `Touch`){
              return this.$router.push({ name : `pos` })
            }
            return this.$router.push({name: 'tables'})
          }
        })
      }
    })
  },
  components: {FloatAssignForm},
  computed:{
    curUser(){
      let user = this.$store.getters.getCurrentUser;
      return this.$store.getters.getCurrentUser.Username
    },
  },
  methods: {
    greeting() {
      const today = new Date();
      const currentHour = today.getHours()
      const currentMin = today.getMinutes()
      if (currentHour >= 0 && (currentHour <= 11 && currentMin <= 59)) {
        return 'Good Morning'
      } else if (currentHour >= 12 && (currentHour <= 17 && currentMin <= 59)) {
        return 'Good Afternoon'
      } else {
        return 'Good Evening'
      }
    }
  }
}
</script>

<style scoped>
.page {
  background: var(--bg-gradient);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.header-section {
  background: var(--bg-gradient);
  padding: 2rem 1.5rem;
  min-height: 30vh;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.header-content {
  max-width: 600px;
  width: 100%;
}

.greeting {
  font-family: var(--font-family);
  font-weight: var(--font-weight-headings);
  font-size: 2.5rem;
  color: var(--text-primary);
  margin-bottom: 0.5rem;
  line-height: 1.2;
}

.username {
  font-family: var(--font-family);
  font-weight: var(--font-weight-body);
  font-size: 1.25rem;
  color: var(--text-secondary);
  margin: 0;
}

.form-section {
  flex: 1;
  background: var(--bg-primary);
  padding: 2rem 1rem;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  margin-top: -1rem;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.1);
}

.form-container {
  width: 100%;
  max-width: 500px;
  animation: fadeIn 0.5s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .greeting {
    font-size: 2rem;
  }

  .header-section {
    min-height: 25vh;
    padding: 1.5rem 1rem;
  }

  .form-section {
    padding: 1.5rem 1rem;
  }
}
</style>
